import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import 'react';
import { themed } from '@indeed/ifl-css';
import createResponsive from '../../utils/createResponsive.js';
import { useEmptyStateContext } from './context.js';
import { jsx } from '@emotion/react';

const sizeToLevelMap = {
  sm: "text.level4",
  md: "text.level5",
  lg: "text.level6"
};
const getVariant = createResponsive(size => sizeToLevelMap[size]);
const StyledEmptyStateTitle = /*#__PURE__*/themed("h2", process.env.NODE_ENV === "production" ? {
  styleProps: ["size"],
  shouldForwardProp: prop => prop !== "size",
  target: "egnapwj0"
} : {
  styleProps: ["size"],
  shouldForwardProp: prop => prop !== "size",
  target: "egnapwj0",
  label: "StyledEmptyStateTitle"
})(_ref => {
  let {
    size = "md"
  } = _ref;
  return {
    marginBlockStart: 0,
    marginBlockEnd: 0,
    marginInlineStart: 0,
    marginInlineEnd: 0,
    color: "foreground.strong",
    fontWeight: "bold",
    fontFamily: "default",
    variant: getVariant(size)
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkVtcHR5U3RhdGVUaXRsZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBc0I4QiIsImZpbGUiOiJFbXB0eVN0YXRlVGl0bGUudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IEZDLCBQcm9wc1dpdGhDaGlsZHJlbiB9IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IHsgdGhlbWVkLCBTdHlsZVByb3BzIH0gZnJvbSBcIkBpbmRlZWQvaWZsLWNzc1wiO1xuaW1wb3J0IGNyZWF0ZVJlc3BvbnNpdmUgZnJvbSBcIi4uLy4uL3V0aWxzL2NyZWF0ZVJlc3BvbnNpdmVcIjtcbmltcG9ydCB7IEVtcHR5U3RhdGVTaXplIH0gZnJvbSBcIi4vRW1wdHlTdGF0ZVwiO1xuaW1wb3J0IHsgdXNlRW1wdHlTdGF0ZUNvbnRleHQgfSBmcm9tIFwiLi9jb250ZXh0XCI7XG5cbmludGVyZmFjZSBTdHlsZWRFbXB0eVN0YXRlVGl0bGVQcm9wcyB7XG4gIHNpemU6IEVtcHR5U3RhdGVTaXplIHwgQXJyYXk8RW1wdHlTdGF0ZVNpemU+O1xufVxuXG5leHBvcnQgdHlwZSBFbXB0eVN0YXRlVGl0bGVQcm9wcyA9IFN0eWxlUHJvcHM7XG5cbmNvbnN0IHNpemVUb0xldmVsTWFwID0ge1xuICBzbTogXCJ0ZXh0LmxldmVsNFwiLFxuICBtZDogXCJ0ZXh0LmxldmVsNVwiLFxuICBsZzogXCJ0ZXh0LmxldmVsNlwiXG59O1xuXG5jb25zdCBnZXRWYXJpYW50ID0gY3JlYXRlUmVzcG9uc2l2ZTxFbXB0eVN0YXRlU2l6ZT4oXG4gIHNpemUgPT4gc2l6ZVRvTGV2ZWxNYXBbc2l6ZV1cbik7XG5cbmNvbnN0IFN0eWxlZEVtcHR5U3RhdGVUaXRsZSA9IHRoZW1lZChcImgyXCIsIHtcbiAgc3R5bGVQcm9wczogW1wic2l6ZVwiXSxcbiAgc2hvdWxkRm9yd2FyZFByb3A6IHByb3AgPT4gcHJvcCAhPT0gXCJzaXplXCJcbn0pPFN0eWxlZEVtcHR5U3RhdGVUaXRsZVByb3BzPigoeyBzaXplID0gXCJtZFwiIH0pID0+ICh7XG4gIG1hcmdpbkJsb2NrU3RhcnQ6IDAsXG4gIG1hcmdpbkJsb2NrRW5kOiAwLFxuICBtYXJnaW5JbmxpbmVTdGFydDogMCxcbiAgbWFyZ2luSW5saW5lRW5kOiAwLFxuICBjb2xvcjogXCJmb3JlZ3JvdW5kLnN0cm9uZ1wiLFxuICBmb250V2VpZ2h0OiBcImJvbGRcIixcbiAgZm9udEZhbWlseTogXCJkZWZhdWx0XCIsXG4gIHZhcmlhbnQ6IGdldFZhcmlhbnQoc2l6ZSlcbn0pKTtcblxuZXhwb3J0IGNvbnN0IEVtcHR5U3RhdGVUaXRsZTogRkM8XG4gIFByb3BzV2l0aENoaWxkcmVuPEVtcHR5U3RhdGVUaXRsZVByb3BzPlxuPiA9IHByb3BzID0+IHtcbiAgY29uc3QgeyBzaXplIH0gPSB1c2VFbXB0eVN0YXRlQ29udGV4dCgpO1xuXG4gIHJldHVybiA8U3R5bGVkRW1wdHlTdGF0ZVRpdGxlIHNpemU9e3NpemV9IHsuLi5wcm9wc30gLz47XG59O1xuXG5FbXB0eVN0YXRlVGl0bGUuZGlzcGxheU5hbWUgPSBcIkVtcHR5U3RhdGVUaXRsZVwiO1xuIl19 */");
const EmptyStateTitle = props => {
  const {
    size
  } = useEmptyStateContext();
  return jsx(StyledEmptyStateTitle, _extends({
    size: size
  }, props));
};
EmptyStateTitle.displayName = "EmptyStateTitle";

export { EmptyStateTitle };
